
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { useCatalog, useMetadataCatalog } from "@/store";
import { defineComponent } from "@vue/composition-api";
import { zipObject } from "lodash";
import { mapState } from "pinia";
import config from "@/util/constants";

export default defineComponent({
  name: "AddDataDesc",
  data: () => ({
    unitsTbl: new Array<any>(),
    standardFieldTbl: new Array<any>(),
    dpRequest: {} as IDataProviderRequest,
    fields: new Array<string>(),
    items: new Array<any>(),

    // unitsTblN: "units",
    // fieldCatTblN: "field_cat",
    // standardFieldTblN: "standard_field",
    // tblPath: "/data_mgmt/all/System/",

    unitsTblN: config.metaCat.v_units,
    fieldCatTblN: config.metaCat.v_field_cat,
    standardFieldTblN: config.metaCat.v_standard_field,
    tblPath: "/meta_cat/",

    dataCatEntry: {
      data_cat_id: { val: null, type: Number, isRequired: true },
      is_primary_key: { val: null, type: Boolean, isRequired: true },
      is_spatial_field: { val: null, type: Boolean, isRequired: true },
      field_name: { val: null, type: String, isRequired: true },
      field_nice_name: { val: null, type: String, isRequired: true },
      field_short_desc: { val: null, type: String, isRequired: true },
      field_long_desc: { val: null, type: String, isRequired: false },
      calc_method_desc: { val: null, type: String, isRequired: true },
      units_id: { val: null, type: Number, isRequired: false },
      is_critical_data: { val: null, type: Boolean, isRequired: false },
      created_date: { val: null, type: String, isRequired: false },
      is_standard_field: { val: null, type: Boolean, isRequired: false },
      standard_field_id: { val: null, type: Number, isRequired: false },
      update_log_id: { val: null, type: Number, isRequired: true },
      data_type: { val: null, type: String, isRequired: false },
    },

    is_standard_field: false,
  }),
  computed: {
    ...mapState(useCatalog, ["tableMeta", "tableData"]),
    ...mapState(useMetadataCatalog, [
      "fieldCatUri",
      "updateLogId",
      "selectedDataCatId",
    ]),
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    updateIsStandardField(val: boolean) {
      this.is_standard_field = val;
    },
    async resetVar() {
      this.dataCatEntry.is_primary_key.val = null;
      this.dataCatEntry.is_spatial_field.val = null;
      this.dataCatEntry.field_name.val = null;
      this.dataCatEntry.field_nice_name.val = null;
      this.dataCatEntry.field_short_desc.val = null;
      this.dataCatEntry.field_long_desc.val = null;
      this.dataCatEntry.calc_method_desc.val = null;
      this.dataCatEntry.units_id.val = null;
      this.dataCatEntry.is_critical_data.val = null;
      this.dataCatEntry.created_date.val = null;
      this.dataCatEntry.is_standard_field.val = null;
      this.dataCatEntry.standard_field_id.val = null;
      this.dataCatEntry.data_type.val = null;
      return true;
    },
    async init() {
      await this.resetVar();
      this.dataCatEntry.data_cat_id.val = this.selectedDataCatId;
      this.dataCatEntry.update_log_id.val = this.updateLogId;
      await this.catalogChange(this.unitsTblN);
      await this.catalogChange(this.standardFieldTblN);
    },
    async loadData(tableName: string, columns: Array<string>) {
      await useCatalog()
        .getTableData({
          catalogUri: this.tblPath + tableName,
          request: this.dpRequest,
        })
        .then(() => this.setTableData(tableName, columns));
    },
    setTableData(tableName: string, columns: Array<string>) {
      if (this.tableData?.rows.length) {
        switch (tableName) {
          case this.unitsTblN:
            this.unitsTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.standardFieldTblN:
            this.standardFieldTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          default:
            this.showMessage(
              "danger",
              "Couldn't find the matching table name!! - " + tableName
            );
            break;
        }
      }
    },
    async catalogChange(tableName: string) {
      // Retrieve table meta
      await useCatalog()
        .getTableMeta({
          catalogUri: this.tblPath + tableName,
          request: {},
        })
        .then(() => {
          this.setTableColumns(tableName);
        });
    },
    setTableColumns(tableName: string) {
      if (this.tableMeta?.columns.length) {
        let columns = this.tableMeta.columns.map(
          (c: { columnName: string }) => c.columnName
        );
        this.loadData(tableName, columns);
      }
    },
    async updateDB(param: string) {
      const methodN = "updateDB";
      const requestFrom = "field_cat";
      const nextPage = "endWorkflow";
      const catUri = this.tblPath + this.fieldCatTblN;

      this.$emit(
        methodN,
        requestFrom,
        param,
        this.dataCatEntry,
        nextPage,
        catUri,
        this.fieldCatUri
      );
    },
    showMessage(type: string, msg: string) {
      this.$root.$emit("showAlert", 4, type, msg);
    },
  },
});
